var base = 5;
var spaces = {
    // Gaps
    desktop: {
        xs: "".concat(base, "px"),
        s: "".concat(base * 2, "px"),
        m: "".concat(base * 3, "px"), // 18px
        mL: "".concat(base * 4, "px"), // 24px
        l: "".concat(base * 6, "px"), // 36px
        xl: "".concat(base * 8, "px"), // 48px
        xxl: "".concat(base * 10, "px"), // 60px
        // Spacer
        spacer: '80px',
        sectionSpacer: '180px'
    },
    mobile: {
        xs: "".concat(base, "px"),
        s: "".concat(base * 2, "px"), // 20px
        m: "".concat(base * 3, "px"), // 24px
        mL: "".concat(base * 4, "px"), // 30px
        l: "".concat(base * 5, "px"), // 50px
        xl: "".concat(base * 9, "px"), // 80px
        spacer: "".concat(base * 15, "px"),
        sectionSpacer: "".concat(base * 25, "px")
    }
};
export default spaces;
